import { render, staticRenderFns } from "./robotAddPowder.vue?vue&type=template&id=66588390&scoped=true"
import script from "./robotAddPowder.vue?vue&type=script&lang=js"
export * from "./robotAddPowder.vue?vue&type=script&lang=js"
import style0 from "./robotAddPowder.vue?vue&type=style&index=0&id=66588390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66588390",
  null
  
)

export default component.exports